function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { assert } from "@ember/debug";
import ForcJournalEventBaseComponent from "core/components/forc/abstract/journal-event-based-component";
import retrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import JournalEventModel from "core/models/journal-event";
import SurveyCompletedJournalEvent from "core/models/survey-completed-journal-event";
import { getLastSurveyCompleted } from "core/utils/journal-events";
import { ForcBaseArgs } from "./base-component";
import { Payload } from "./journal-event-based-component";
var _retrieveSurveyCompletedJournalEvent = /*#__PURE__*/new WeakMap();
export default class ForcSurveyBasedComponent extends ForcJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    /***********************
     *   PUBLIC INTERFACE
     ***********************/
    _defineProperty(this, "autoSaveDraft", true);
    _classPrivateFieldInitSpec(this, _retrieveSurveyCompletedJournalEvent, () => {
      return this.sourceJeId ? retrievalStrategies.sourceJournalEvent.call(this) : getLastSurveyCompleted(this.patient.surveyCompletedJournalEvents, this.fullComponentId);
    });
  }
  retrieveModel() {
    assert(`You should not override the strategy for the '${this.constructor.name}' which extends the 'ForcSurveyBasedComponent' without talking about it with the Tech Team and Florian because the 'SurveyCompleted' have a specific behavior. In fact you cant't use a global strategy as you should be aware of the formId.`, !this.retrieveJournalEvent());
    const surveyCompletedJournalEvent = _classPrivateFieldGet(_retrieveSurveyCompletedJournalEvent, this).call(this);
    if (surveyCompletedJournalEvent) {
      return surveyCompletedJournalEvent.rawInputs;
    }
    return {};
  }

  /**
   * We need to override the compute payload because this component
   * do not use the 'journalEventProperties' from the super class.
   * In fact, here the model is the full content of the changeset and it's what we want.
   */
  computePayload() {
    // We have to return a copy of the model here because the model is actually
    // rendered and observed at this moment of the life cycle.
    // Here it will work to return directly the model because we don't modify it.
    // But if someone override this method and call super.computePayload() and then try
    // to modify the returned payload without using the 'set' method from '@ember/object'.
    // Then this will break the process which is the saving of the form.
    return Object.assign({}, this.model);
  }
  async saveModel() {
    // If we are in edit mode we first need to archive the old JE
    if (this.isEditMode) {
      await this.sourceJournalEvent.archive();
    }
    const payload = this.computePayload();

    // If it's edition mode then we search for the date in the source journal event.
    // Otherwise we take the one of the payload or we create a new one.
    const occurredAt = this.isEditMode ? this.sourceJournalEvent.occurredAt : payload.occurredAt || new Date();
    const surveyCompleted = this.store.createRecord(this.journalEventClassType, {
      patient: this.patient,
      occurredAt: occurredAt,
      rawInputs: payload,
      formId: this.fullComponentId,
      // By default, it links the surveyRequested if the form was displayed through a /form-requested route
      surveyRequestedJournalEvent: this.args.surveyRequested
    });
    await surveyCompleted.save();
  }
}
/***********************/
_defineProperty(ForcSurveyBasedComponent, "journalEventClass", SurveyCompletedJournalEvent);